
import {defineComponent} from 'vue';
import json from '@/assets/megami_list.json';

export default defineComponent({
  'name': 'MegamiSlotCylinder',
  'props': {
    'code': {
      'type': String,
      'required': true,
    },
  },
  setup(props) {
    const megami = json.megamiList.find(m => m.code === props.code);
    return {
      megami,
    };
  },
});
